import { Button } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
const NotFound = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/");
  };
  return (
    <div style={{ marginTop: 67, marginBottom: 10 }}>
      <h1 style={{ color: "white" }}>404 error | page not found</h1>

      <Button
        style={{ color: "white", border: "1px solid white" }}
        onClick={handleClick}
      >
        Back to homepage
      </Button>
    </div>
  );
};
export default NotFound;
